import { makeStyles } from "@material-ui/core";

export default makeStyles(
  () => ({
    player: {
      height: "100%",
      overflow: "hidden",
    },
  }),
  { name: "StarringYouClip" },
);
